import { FC, useEffect, useState } from "react";
import KIT from './assets/KIT.jpg';
import KOFD from './assets/KOFD.jpg';
import PROJ from './assets/PROJ.jpg';
import PROV from './assets/PROV.jpg';
import AVULSO from './assets/AVULSO.png';
import HIBRI from './assets/HIBRI.jpg';

interface AvatarTipoProperties {
    codigo_venda: string;
}
const AvatarTipo: FC<AvatarTipoProperties> = ({
    codigo_venda
}) => {
    const [imgPath, setImgPath] = useState<string>();

    useEffect(() => {
        if (codigo_venda) {
            //const tipo_projeto = codigo_venda.substring(0,4)
            const tipo_projeto = codigo_venda.replace(/[^A-Za-z]+/g, '');
            switch (tipo_projeto) {
                case "PROJ":
                    setImgPath(PROJ);
                    break;
                case "PROV":
                    setImgPath(PROV);
                    break;
                case "KOND":
                    setImgPath(KIT);
                    break;
                case "KOFD":
                    setImgPath(KOFD);
                    break;
                case "KONV":
                    setImgPath(KIT);
                    break;
                case "KOFV":
                    setImgPath(KOFD);
                    break;
                case "KIT":
                    setImgPath(KIT);
                    break;
                case "KITV":
                    setImgPath(KIT);
                    break;
                case "KOFS":
                case "PROFF":
                    setImgPath(KOFD);
                    break;
                case "AVS":
                    setImgPath(AVULSO);
                    break;
                case "HIBRI":
                    setImgPath(HIBRI);
                    break;
                default:
                    break;
            }
        }
    }, [codigo_venda])
    return (<>
        {imgPath && (
            <img style={{ maxWidth: "50px" }} src={imgPath}></img>
        )}
    </>
    )
}
export { AvatarTipo }